<template>
    <div>
        <v-dialog v-model="dialog" max-width="600">
            <v-card>
                <v-toolbar dense flat color="teal" dark>
                    <v-toolbar-title>
                        {{ $t("common.add") }} {{ $t(`data_select.${type}`) }}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-form ref="form" lazy-validation @submit.prevent="1">
                            <v-row>
                                <v-col cols="12">
                                    <strong>{{ $t('common.name') }} *</strong>
                                    <w-text-field
                                        v-model="entity.name"
                                        :rules="[mxRules.required]"
                                        :color="color"
                                    ></w-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <strong>الاسم</strong>
                                    <w-text-field
                                        v-model="entity.arabicName"
                                        :color="color"
                                    ></w-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            depressed
                            color="blue darken-2"
                            outlined
                            @click="dialog = false"
                        >
                            {{ $t("common.close") }}
                            <v-icon right>mdi-close</v-icon>
                        </v-btn>
                        <v-btn
                            depressed
                            :loading="loading"
                            color="teal"
                            dark
                            @click="save"
                        >
                            {{ $t("common.add") }}
                            <v-icon right>mdi-plus-circle-outline</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-autocomplete
            v-model="dataSelect"
            :label="showDefaultLabel ? $t(`data_select.${type}`) : label"
            :items="dataSelects"
            item-value="id"
            item-text="name"
            outlined
            dense
            placeholder="Veuillez séléctionner"
            :clearable="!readonly && !multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :color="color ? color : inputColor"
            :background-color="color ? color + ' lighten-5' : inputBackgroundColor"
            hide-details="auto"
            :loading="loading"
            @input="$emit('input', dataSelect)"
            :disabled="disabled"
            :readonly="readonly"
            :multiple="multiple"
            :rules="rules"
            :hint="hint"
            :persistent-hint="persistentHint"
            @click:prepend-inner="dialog = true"
        >
            <!-- :prepend-inner-icon="securityStore.authorities.UPDATE_GENERAL_PARAM && !readonly ? 'mdi-plus-circle-outline' : ''" -->
        </v-autocomplete>

        <input type="hidden"/>
    </div>
</template>

<script>
import {ref, watch, onMounted} from "vue";
import {useDataSelectStore} from "@/stores/DataSelect.js";
import {useSecurityStore} from "@/stores/Security.js";
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import useValidation from "@/use/Validation.js";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    props: {
        value: [Number, Array],
        type: String,
        multiple: Boolean,
        selectDefault: Boolean,
        label: String,
        color: String,
        disabled: Boolean,
        readonly: Boolean,
        showDefaultLabel: Boolean,
        rules: Array,
        hint: String,
        persistentHint: Boolean,
    },
    setup(props, context) {
        const {$refs} = useTools();
        const {transformFilterValues} = useSharedMethod();
        const dataSelect = ref(props.multiple ? [] : null);
        const dataSelects = ref([]);

        const entity = ref({
            primary: false,
            type: props.type,
        });

        const {mxRules} = useValidation();
        const {filter, loading, inputColor, inputBackgroundColor, dialog} = useSharedData();
        dialog.value = false;
        const dataSelectStore = useDataSelectStore();
        const securityStore = useSecurityStore();

        // Computed property for client-side filtering
        /*const filteredItems = computed(() => {
            const items = dataSelectStore.dataSelectsSelect[props.type] || [];
            if (!searchInput.value || dataSelect.value || dataSelect.value.length > 0) {
                return items;
            }

            const search = searchInput.value.toLowerCase();
            return items.filter(item =>
                item.name.toLowerCase().includes(search) ||
                (item.arabicName && item.arabicName.toLowerCase().includes(search))
            );
        });*/

        watch(() => props.value, () => {
            dataSelect.value = props.value;
        }, {immediate: true});

        watch(() => props.type, () => {
            findAll();
        }, {immediate: true});

        function findAll() {
            loading.value = true;
            filter.value.allRecords = true;
            filter.value.type = props.type;
            axios.get('/dataSelects', {
                params: transformFilterValues(filter.value),
            }).then((response) => {
                dataSelectStore.setDataSelectsSelect(response.data, props.type);
                dataSelects.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function save() {
            if ($refs.form.validate()) {
                loading.value = true;
                axios.post('/dataSelects', entity.value).then((response) => {
                    dataSelectStore.addDataSelectsSelect(response.data, props.type);
                    dataSelects.value.push(response.data);
                    if (props.multiple) {
                        dataSelect.value.push(response.data.id);
                    } else {
                        dataSelect.value = response.data.id;
                    }
                    context.emit('input', dataSelect.value);
                    dialog.value = false;
                    entity.value = {
                        primary: false,
                        type: props.type,
                    };
                }).finally(() => {
                    loading.value = false;
                });
            }
        }

        onMounted(() => findAll());

        return {
            dataSelectStore,
            securityStore,
            dataSelect,
            dataSelects,
            loading,
            dialog,
            inputColor,
            inputBackgroundColor,
            entity,
            mxRules,
            save,
        }
    },
};
</script>